var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.75 23.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75,8.2v9.74a2.17,2.17,0,0,1-2.09,2.43h-.18l.68,2.69-4.67-2.69H11.3a2.85,2.85,0,0,1-2.84-2.43v-.42h16a2.4,2.4,0,0,0,2.44-2.61V6.11h.81A1.9,1.9,0,0,1,29.75,8.2ZM25.16,2.79v11c0,1.37-1.51,2.34-3.13,2.34H8.48L2.12,19.83l1-3.7C1.59,16,0,15.08,0,13.82v-11C0,1.42,1.88,0,3.5,0H22A3.18,3.18,0,0,1,25.16,2.79ZM8,7.66A1.67,1.67,0,1,0,6.33,9.31,1.66,1.66,0,0,0,8,7.66Zm6.25,0a1.67,1.67,0,1,0-1.67,1.65A1.66,1.66,0,0,0,14.25,7.66Zm6.25,0a1.67,1.67,0,1,0-1.67,1.65A1.66,1.66,0,0,0,20.5,7.66Z",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.38c8af734e796c4f4cfa3c7a249f1c60.svg";
export { ForwardRef as ReactComponent };